import React from "react";
import { Button, Tooltip } from "antd";
import { CREATE_CMR } from "../../../constants/translates";

interface Props {
  message?: string;
}

const DisabledButton: React.FC<Props> = ({ message = "" }) => {
  return (
    <Tooltip placement="top" title={message}>
      <Button type="primary" size="small" disabled>
        {CREATE_CMR}
      </Button>
    </Tooltip>
  );
};

export default DisabledButton;
